import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5d38db4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6" }, " Como deseja apresentar os produtos contados? ", -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_4 = { class: "ant-table-column-title" }
const _hoisted_5 = { class: "ant-table-column-sorter ant-table-column-sorter-full" }
const _hoisted_6 = { class: "ant-table-column-sorter-inner ant-table-column-sorter-inner-full" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  class: "anticon anticon-caret-up ant-table-column-sorter-up"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z" })
  ])
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  class: "anticon anticon-caret-down ant-table-column-sorter-down"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 1024 1024"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z" })
  ])
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "acoes-item"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_19 = { class: "ss-box-passo-balanco" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ss-titulo-destaque ss-alinhar-texto-centro" }, "1° Passo", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Baixe o arquivo de modelo de importação do balanço e preencha conforme a sua contagem.", -1))
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_23 = { class: "ss-box-passo-balanco" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ss-titulo-destaque ss-alinhar-texto-centro" }, "2° Passo", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Após preencher o arquivo e verificar se todas as informações estão corretas, selecione o arquivo clicando no botão abaixo.", -1))
const _hoisted_26 = {
  class: "ant-btn ss-tamanho-completo",
  type: "button",
  "ant-click-animating-without-extra-node": "false"
}
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_28 = { class: "ss-box-passo-balanco" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ss-titulo-destaque ss-alinhar-texto-centro" }, "3° Passo", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Agora é necessário confirmar em qual estoque os produtos e quantidades contadas devem ser vinculadas:", -1))
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Iniciar importação", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ss-titulo-destaque ss-alinhar-texto-centro" }, "Resumo da importação", -1))
const _hoisted_38 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_balanco_estoque_contagem = _resolveComponent("balanco-estoque-contagem")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_busca_avancada = _resolveComponent("busca-avancada")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_selecionar_estoque = _resolveComponent("selecionar-estoque")!
  const _component_barra_progresso = _resolveComponent("barra-progresso")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_lancamento_rastreabilidade_modal = _resolveComponent("lancamento-rastreabilidade-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_requisicao_modal, {
      visivel: _ctx.modalBase.exibirRequisicaoModal,
      "onUpdate:visivel": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
      apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
      retornoRequisicao: _ctx.modalBase.retornoRequisicao
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"]),
    _withDirectives(_createVNode(_component_balanco_estoque_contagem, {
      ref: "refBalancoEstoqueContagem",
      codigoBalancoEstoque: _ctx.props.codigoBalancoEstoque,
      codigoEmpresa: _ctx.props.codigoEmpresa,
      onConfirmadaContagemEstoque: _ctx.confirmadaContagemEstoque
    }, null, 8, ["codigoBalancoEstoque", "codigoEmpresa", "onConfirmadaContagemEstoque"]), [
      [_vShow, _ctx.permitirLancamento()]
    ]),
    _createVNode(_component_a_collapse, {
      ghost: "",
      class: "ss-accordion"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_collapse_panel, {
          key: "1",
          header: "PRODUTOS CONTADOS"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.state.modoApresentacaoProdutos,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.modoApresentacaoProdutos) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.verificaAlteracaoApresentacaoItens()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, {
                      value: _ctx.EApresentarProdutosContados.UltimosLancamentos
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Últimos lançamentos")
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_a_radio, {
                      value: _ctx.EApresentarProdutosContados.TodosProdutos
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Todos produtos")
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_a_radio, {
                      value: _ctx.EApresentarProdutosContados.BuscaAvancada
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Busca avançada")
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(_component_busca_avancada, {
                buscaAvancada: _ctx.gradeBase.buscaAvancada,
                "onUpdate:buscaAvancada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.gradeBase.buscaAvancada) = $event)),
                visivel: true,
                marginPadrao: false,
                empresas: [_ctx.props.codigoEmpresa],
                onAplicarFiltros: _ctx.aplicarFiltros
              }, null, 8, ["buscaAvancada", "empresas", "onAplicarFiltros"]),
              (_ctx.gradeBase.buscaAvancada.filtrosAdicionados.length <= 0)
                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                    key: 0,
                    resultadoPesquisa: true,
                    mensagem: "Adicione os filtros para localizar um ou mais produtos no balanço de estoque."
                  }))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.state.modoApresentacaoProdutos === _ctx.EApresentarProdutosContados.BuscaAvancada]
            ]),
            _createElementVNode("div", null, [
              _withDirectives((_openBlock(), _createBlock(_component_a_table, {
                key: _ctx.computedCodigoEmpresa,
                columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                "data-source": _ctx.state.itens,
                rowKey: "codigoDefinicao",
                pagination: false,
                scroll: { x: _ctx.obtemLarguraGrade(1200) },
                loading: _ctx.gradeBase.buscandoDados,
                size: "small"
              }, {
                headerCell: _withCtx(({ column }) => [
                  (column.ordering)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: column.key,
                        class: "ss-coluna-ordenada"
                      }, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(column.title), 1),
                        _createElementVNode("span", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            (_openBlock(), _createElementBlock("a", {
                              title: "Ordenação crescente",
                              key: 'ord-asc' + column.key,
                              class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'ASC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                              onClick: ($event: any) => (_ctx.ordenarDados(column.key,'ASC'))
                            }, _hoisted_9, 10, _hoisted_7)),
                            (_openBlock(), _createElementBlock("a", {
                              title: "Ordenação decrescente",
                              key: 'ord-desc' + column.key,
                              class: _normalizeClass([_ctx.ordenacaoAtiva(column.key,'DESC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                              onClick: ($event: any) => (_ctx.ordenarDados(column.key,'DESC'))
                            }, _hoisted_12, 10, _hoisted_10))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                bodyCell: _withCtx(({ column, record, index }) => [
                  (column.key === 'quantidadeContada')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.aplicarCasasDecimaisQuantidade(record.quantidadeContada, record.casasDecimais)), 1)
                      ], 64))
                    : (column.key === 'acoes')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("a", {
                            title: "Editar contagem",
                            class: "visualizar",
                            onClick: ($event: any) => (_ctx.editarContagem(record))
                          }, [
                            _createVNode(_component_icone, { nome: "editar" })
                          ], 8, _hoisted_14),
                          _createElementVNode("a", {
                            title: "Excluir contagem",
                            onClick: ($event: any) => (_ctx.confirmaExclusao(record)),
                            class: "excluir"
                          }, [
                            _createVNode(_component_icone, { nome: "excluir" })
                          ], 8, _hoisted_15),
                          (record.tipoRastreabilidade !== _ctx.ETipoRastreabilidade.Nenhum)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                title: "Adicionar Rastreabilidade",
                                class: "visualizar",
                                onClick: ($event: any) => (_ctx.lancarRastreabilidade(index))
                              }, [
                                _createVNode(_component_icone, { nome: "estoque" })
                              ], 8, _hoisted_16))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                ]),
                emptyText: _withCtx(() => [
                  _createVNode(_component_mensagem_sem_dados, {
                    adicionarDado: true,
                    mensagem: _ctx.gradeBase.buscandoDados?'Buscando informações, por favor aguarde...':'Nenhum item encontrado, verifique os seus filtros ou adicione uma contagem.'
                  }, null, 8, ["mensagem"])
                ]),
                _: 1
              }, 8, ["columns", "data-source", "scroll", "loading"])), [
                [_vShow, _ctx.verificaApresentacaoItens()]
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_collapse_panel, {
          key: "2",
          header: "IMPORTAR ARQUIVO"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _hoisted_21,
                    _createElementVNode("a", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.baixarModeloImportacaoArquivo()))
                    }, "Baixar modelo em branco"),
                    _createElementVNode("a", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.baixarModeloImportacaoArquivo(true)))
                    }, " Baixar modelo com todos os produtos cadastrados")
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _hoisted_25,
                    _createVNode(_component_a_upload, {
                      "file-list": _ctx.state.listaArquivos,
                      "onUpdate:fileList": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.listaArquivos) = $event)),
                      multiple: false,
                      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      "before-upload": _ctx.prepararArquivoUpload,
                      onRemove: _ctx.removerArquivo
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", _hoisted_26, [
                          _createElementVNode("span", null, [
                            _createVNode(_component_icone, { nome: "upload-nuvem" }),
                            _createTextVNode(" Selecionar arquivo")
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["file-list", "accept", "before-upload", "onRemove"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _hoisted_30,
                    _createVNode(_component_selecionar_estoque, {
                      placeholder: "Selecionar estoque",
                      codigoSelecionado: _ctx.state.codigoEstoqueImportacao,
                      "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.codigoEstoqueImportacao) = $event)),
                      empresas: [_ctx.props.codigoEmpresa]
                    }, null, 8, ["codigoSelecionado", "empresas"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-primary ant-btn-lg ss-tamanho-altura-completo",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.importarArquivoBalanco()))
                  }, _hoisted_34)
                ])
              ], 512), [
                [_vShow, (_ctx.state.listaArquivos.length > 0)]
              ])
            ], 512), [
              [_vShow, (!_ctx.state.importacaoArquivoEmAndamento)]
            ]),
            _createVNode(_component_barra_progresso, {
              visivel: _ctx.state.importacaoArquivoEmAndamento,
              frase: "Aguarde por favor... Estamos importando o seu arquivo e tratando algumas informações."
            }, null, 8, ["visivel"]),
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_35,
              _hoisted_36,
              _hoisted_37,
              _createElementVNode("textarea", {
                rows: "10",
                value: _ctx.state.resumoImportacaoArquivo,
                class: "ant-input ss-tamanho-completo"
              }, null, 8, _hoisted_38)
            ], 512), [
              [_vShow, (_ctx.UtilitarioGeral.valorValido(_ctx.state.resumoImportacaoArquivo))]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lancamento_rastreabilidade_modal, {
      empresa: _ctx.props.codigoEmpresa,
      visivel: _ctx.state.exibirLancamentoRastreabilidade,
      "onUpdate:visivel": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.exibirLancamentoRastreabilidade) = $event)),
      codigoDefinicaoProduto: _ctx.state.codigoDefinicaoSelecionado,
      itemEstoque: _ctx.state.codigoItemEstoqueSelecioando,
      recurso: 'BALANCO_ESTOQUE',
      quantidade: _ctx.state.quantidadeSelecionado,
      rastreabilidades: _ctx.state.rastreabilidades,
      "onUpdate:rastreabilidades": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.rastreabilidades) = $event)),
      codigoOperacao: _ctx.state.codigoItemSelecionado,
      codigoTipoOperacao: _ctx.props.codigoBalancoEstoque,
      codigoUnidade: _ctx.state.codigoUnidadeSelecionado,
      fatorConversao: _ctx.state.fatorConversao
    }, null, 8, ["empresa", "visivel", "codigoDefinicaoProduto", "itemEstoque", "quantidade", "rastreabilidades", "codigoOperacao", "codigoTipoOperacao", "codigoUnidade", "fatorConversao"])
  ]))
}